import { getApiInstance } from './api.helpers';
import { getLanguageHeaders } from './locales';
export const getNonVisitGroups = async ({ environment, siteId, participantId, siteUserLocale, }) => {
    if (!environment) {
        return [];
    }
    const response = await getApiInstance(environment).get(`/v2/routes/c_sites/${siteId}/c_public_users/${participantId}/non_visit_groups`, {
        ...getLanguageHeaders(siteUserLocale),
        params: {
            limit: 100,
            skip: 0,
            sort: -1,
        },
    });
    return (response ? response?.data.data : []).filter((responseData) => !responseData.is_patient_tasks);
};
export const getOnboardingData = async ({ environment, siteId, participantId, siteUserLocale, onboardingGroupId, }) => {
    if (!environment) {
        return [];
    }
    const response = await getApiInstance(environment).get(`/v2/routes/c_sites/${siteId}/c_public_users/${participantId}/c_groups/${onboardingGroupId}/c_task_assignments`, {
        ...getLanguageHeaders(siteUserLocale),
        params: {
            dedupeByAssignment: true,
        },
    });
    return response ? response?.data.data : [];
};
